module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-inner-2400.f92e6637.svg";